// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthAmenity\ApiBerthAmenity.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthAmenityType, BerthAmenityTypeData, BerthAmenityTypeOptions } from 'data/models/BerthAmenityType';

// BerthAmenityData is the class that BerthAmenity serializes to/from
export interface BerthAmenityData {
    Id : number;
    Url : string | null;
	
    Amenity : BerthAmenityTypeData | null;
    AmenityId : number;
    Berth : BerthData | null;
    BerthId : number;
	
    Guid : /* GUID */ string;
}

// BerthAmenityOptions is the class which may be passed to the BerthAmenity constructor to define optional initial data values
export interface BerthAmenityOptions {
    Id : number;
    Url? : string | null;
	
    Amenity? : BerthAmenityTypeOptions | null;
    AmenityId? : number;
    Berth? : BerthOptions | null;
    BerthId? : number;
	
    Guid? : /* GUID */ string;
}

export class BerthAmenity {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Amenity : DataSignal<BerthAmenityType | null>;
    public AmenityId : DataSignal<number>;
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
	
    public Guid : DataSignal<string>;

    constructor();
    constructor(data : BerthAmenityOptions);
    constructor(data: BerthAmenityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Amenity = S.value<BerthAmenityType | null>(null);
        this.AmenityId = jsonableObservable(S.value<number>(data && data.AmenityId !== undefined ? data.AmenityId : 0));
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
	    
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
    }

    static key(obj : BerthAmenity) {
        return obj.Id();
    }
    
    static dataKey(obj : BerthAmenityOptions) {
        return obj.Id;
    }

    static update(obj : BerthAmenity, data : BerthAmenityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.AmenityId !== undefined) obj.AmenityId(data.AmenityId);
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
	        
            if (data.Guid !== undefined) obj.Guid(data.Guid);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthAmenity.ts